import { serverApi } from '../../../../services/server-api/server-api';

export async function getFeedbackStatus({ orgUrl, body }) {
  return serverApi.POST({ path: '/api/data/v9.0/CustomerExperienceSurveysService', body, options: { noTokenRequired: true, baseUrl: orgUrl, cacheOptions: { cache: false } } });
}
